module.exports = __webpack_public_path__ + "0680dce35d299b599d48b4f00955f7f1.pdf";